import React from "react";
import {
  Breadcrumb,
  Callout,
  DetailsList,
  DetailsListLayoutMode,
  DetailsRow,
  DirectionalHint,
  Fabric,
  IColumn,
  IDetailsListProps,
  IDetailsRowStyles,
  IDropdownOption,
  PrimaryButton,
  SelectionMode,
  Stack,
  Text,
  TooltipHost,
} from "@fluentui/react";
import { mdiDotsVertical, mdiPencilOutline, mdiTrashCanOutline } from "@mdi/js";
import { useHistory, useParams } from "react-router-dom";
import {
  getAllDataCenters,
  getAllDataCentersOfCustomer,
} from "../../../services/datacenter/DatacenterService";
import { THEME, BRAND_SECONDARY } from "../../../utils/Styles";
import { IAuthorizedContacts, ICustomers } from "../../../vm";
import { AUTHORIZED_CONTACTS_SOURCE_DICT, childrenGap, childrenGap8 } from "../../common/Constants";
import NoDataTile from "../../common/NoDataTile";
import Icon from "@mdi/react";
import {
  deleteAuthorizedContacts,
  getAllCustomers,
  getAuthorizedContacts,
} from "../../../services/customers/CustomerService";
import { ToastContext } from "../../common/ToastProvider";
import { ConfirmDialogContext } from "../../common/ConfirmDialogProvider";
import ManageAcDialog from "./ManageAcDialog";
import { Loading } from "../../../services/Loading";
import { parseJwt } from "../../../services/UtilService";
import TotalNumbers from "../../common/TotalNumbers";

export interface AuthorizationContactsProps { }

var datacenterDict: any = {};

const AuthorizationContacts: React.FC<AuthorizationContactsProps> = () => {
  // custom hooks
  const history = useHistory();
  const params: any = useParams();
  const { showToast } = React.useContext(ToastContext);
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);

  const tokenData = parseJwt();

  // state
  const [state, setState] = React.useState({
    isLoading: false,
    authorizedContacts: [],
    allDatacenterDropdown: [],
    searchObj: {
      customerId: params.customerId,
    },
    manageAcDialog: {
      isOpen: false,
      index: undefined,
      data: undefined,
    },
    manageActionsCallout: {
      isOpen: false,
      index: undefined,
      element: undefined,
      data: undefined,
    },
  } as {
    isLoading: boolean;
    authorizedContacts: IAuthorizedContacts[];
    allDatacenterDropdown: IDropdownOption[];
    searchObj: {
      customerId: string;
      datacenterId?: string;
      text?: any;
    };
    manageAcDialog: {
      isOpen: boolean;
      index?: number;
      data?: IAuthorizedContacts;
    };
    manageActionsCallout: {
      isOpen: boolean;
      element: any;
      index?: number;
      data?: IAuthorizedContacts;
    };
  });

  const [customer, setCustomer] = React.useState({
    isLoading: false,
    customer: {
      name: "",
    },
  } as {
    isLoading: boolean;
    customer: any;
  });

  React.useEffect(() => {
    const asyncFunc = async () => {
      await searchDataCenters();
      await getACustomer();
    };
    asyncFunc();
  }, []);

  const getACustomer = async () => {
    setCustomer({ ...customer, isLoading: true });
    let result = await getAllCustomers({ customerId: params.customerId });
    if (result?.success) {
      setCustomer({
        ...customer,
        customer: result.data[0],
        isLoading: false,
      });
    } else {
      setCustomer({ ...customer, isLoading: false });
    }
  };

  const searchDataCenters = async () => {
    setState({ ...state, isLoading: false });

    // let result = await getAllDataCentersOfCustomer(params.customerId);
    let result = await getAllDataCenters();
    if (result?.success) {
      let allDatacenterDropdown: IDropdownOption[] = [];
      result.data.forEach((item) => {
        allDatacenterDropdown.push({
          key: item._id as string,
          text: item.name,
        });
      });

      datacenterDict = result.data.reduce((acc: any, d) => {
        acc[d._id as string] = d.name;
        return acc;
      }, {});
      console.log("datacen", datacenterDict);

      let obj = {
        ...state,
        allDatacenterDropdown,
        datacenterDict,
        isLoading: false,
      };
      setState(obj);
      getAllAuthorizedContacts("", "", obj);
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result?.message || "Error while getting all datacenters",
        "error"
      );
    }
  };

  const getAllAuthorizedContacts = async (
    datacenterId?: string,
    text?: any,
    paramState?: any
  ) => {
    let localState = { ...state };
    if (paramState) {
      localState = { ...paramState };
    }
    setState({ ...state, isLoading: true });
    let searchObj = { ...localState.searchObj };
    if (datacenterId) {
      searchObj.datacenterId = datacenterId;
    }
    if (text) {
      searchObj.text = text;
    }
    let result = await getAuthorizedContacts(searchObj);
    if (result?.success) {
      setState({
        ...localState,
        authorizedContacts: result.data,
        isLoading: false,
      });
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result?.message || "Error while getting authorized contacts",
        "error"
      );
    }
  };

  const handleDialogOpen = (isOpen: boolean, index?: number) => {
    let authorizedContacts = undefined;
    if (index !== undefined) {
      authorizedContacts = { ...state.authorizedContacts[index] };
    }
    setState({
      ...state,
      manageAcDialog: {
        isOpen,
        index,
        data: authorizedContacts,
      },
    });
  };

  const handleDialogClose = (data: IAuthorizedContacts) => {
    let authorizedContacts = [...state.authorizedContacts];
    if (data) {
      if (state.manageAcDialog.index !== undefined) {
        authorizedContacts[state.manageAcDialog.index] = data;
        showToast("Authorized Contact updated successfully", "success");
      } else {
        authorizedContacts.unshift(data);
        showToast("Authorized Contact added successfully", "success");
      }
    }
    setState({
      ...state,
      manageAcDialog: {
        isOpen: false,
        index: undefined,
        data: undefined,
      },
      authorizedContacts,
    });
  };

  const handleLoading = () => {
    setState({
      ...state,
      isLoading: !state.isLoading,
    });
  };

  const deleteAc = async (item: IAuthorizedContacts, index: number) => {
    showConfirmDialog(
      "Are You Sure",
      "Do you want to delete authorized contact",
      async () => {
        setState({
          ...state,
          isLoading: true,
          manageActionsCallout: {
            isOpen: false,
            index: undefined,
            element: undefined,
            data: undefined,
          },
        });
        let result = await deleteAuthorizedContacts(item);
        if (result?.success) {
          showToast("Authorized Contact deleted successfully", "success");
          let authorizedContacts = [...state.authorizedContacts];
          authorizedContacts.splice(index, 1);
          setState({
            ...state,
            authorizedContacts,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              index: undefined,
              element: undefined,
              data: undefined,
            },
          });
        } else {
          setState({
            ...state,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              index: undefined,
              element: undefined,
              data: undefined,
            },
          });
          showToast(
            result.message || "Error while deleting authorized contact",
            "error"
          );
        }
      }
    );
  };

  const _renderItemColumn = (item: any, index: number, column: IColumn) => {
    switch (column.key) {
      case "actions":
        return (
          <span
            onClick={(ele) => handleCallOutOpenClose(true, ele, index, item)}
          >
            <Icon
              path={mdiDotsVertical}
              size={0.9}
              className="pointer"
              color={BRAND_SECONDARY}
            />
          </span>
          // <Stack horizontal>
          //   <TooltipHost
          //     content={`Edit Authorized Contact`}
          //     id={`editEm`}
          //     calloutProps={{ gapSpace: 0 }}
          //     styles={{ root: { display: "inline-block" } }}
          //   >
          //     <span onClick={() => handleDialogOpen(true, index)}>
          //       <Icon
          //         path={mdiPencilOutline}
          //         size={0.8}
          //         className="pointer"
          //         color={THEME.palette.neutralPrimary}
          //       />
          //     </span>
          //   </TooltipHost>
          //   &nbsp;&nbsp;
          //   <TooltipHost
          //     content={`Delete Authorized Contact`}
          //     id={`deleteEm`}
          //     calloutProps={{ gapSpace: 0 }}
          //     styles={{ root: { display: "inline-block" } }}
          //   >
          //     <span onClick={() => deleteAc(item, index)}>
          //       <Icon
          //         path={mdiTrashCanOutline}
          //         size={0.8}
          //         className="pointer"
          //         color={THEME.palette.themePrimary}
          //       />
          //     </span>
          //   </TooltipHost>
          // </Stack>
        );
      case "datacenterId":
        return <span>{datacenterDict[item.datacenterId]}</span>;
      case "source":
        return <span>{item.source ? AUTHORIZED_CONTACTS_SOURCE_DICT[item.source] : 'N/A'}</span>;
      case "name":
        return (
          <Text style={{ fontWeight: 600 }}>
            {item[column.fieldName as any]}
          </Text>
        );
      default:
        return <span>{column.fieldName ? item[column.fieldName] : ""}</span>;
    }
  };

  const _onRenderRow: IDetailsListProps["onRenderRow"] = (props) => {
    const customStyles: Partial<IDetailsRowStyles> = {};
    if (props) {
      if (props.itemIndex % 2 !== 0) {
        customStyles.root = { backgroundColor: "#F3F3F3" };
      }

      return <DetailsRow {...props} styles={customStyles} />;
    }
    return null;
  };

  const onSearch = async () => {
    await getAllAuthorizedContacts();
  };

  const handleCallOutOpenClose = (
    isOpen: boolean,
    ele?: React.MouseEvent<HTMLSpanElement>,
    index?: number,
    data?: IAuthorizedContacts
  ) => {
    setState({
      ...state,
      manageActionsCallout: {
        isOpen,
        element: isOpen ? ele?.currentTarget : undefined,
        index,
        data,
      },
    });
  };

  return (
    <React.Fragment>
      {(state.isLoading || customer.isLoading) && <Loading />}
      <Stack tokens={childrenGap}>
        <Stack.Item>
          <Breadcrumb
            items={[
              {
                text: customer.customer.name,
                key: "name",
                onClick: () => {
                  history.push(`/customers/${customer.customer._id}`);
                },
              },
              {
                text: "Authorized Contacts",
                key: "authorized-contacts",
                isCurrentItem: true,
              },
            ]}
          />
        </Stack.Item>
        <Stack.Item>
          <Stack
            horizontal
            wrap
            tokens={childrenGap}
            horizontalAlign="space-between"
            verticalAlign="center"
          >
            <Stack.Item>
              <TotalNumbers value={state.authorizedContacts.length} />
              {/* <Stack
                horizontal
                wrap
                tokens={childrenGap}
                horizontalAlign="start"
              > */}
              {/* <Stack.Item>
                  <Dropdown
                    placeholder="Select a Datacenter"
                    selectedKey={state.searchObj.datacenterId}
                    styles={{ dropdown: { width: 250 } }}
                    options={state.allDatacenterDropdown}
                    onChange={(e, v: IDropdownOption | undefined) => {
                      if (v) {
                        // let options: IDropdownOption[] = [
                        //   { key: "all", text: "All" } ]
                        // ;
                        // let allDatacenterDropdown = [
                        //   ...state.allDatacenterDropdown,
                        // ];
                        // allDatacenterDropdown = [ ...options, allDatacenterDropdown]
                        setState({
                          ...state,
                          searchObj: {
                            ...state.searchObj,
                            datacenterId: v.key as string,
                          },
                        });
                      }
                    }}
                  />
                </Stack.Item>
                <Stack.Item>
                  <PrimaryButton text="Search" onClick={onSearch} />
                </Stack.Item> */}
              {/* </Stack> */}
            </Stack.Item>
            {![4].includes(tokenData.role) && (
              // {![2, 4].includes(tokenData.role) && (
              <Stack.Item>
                <PrimaryButton
                  text="Add Authorized Contact"
                  onClick={() => handleDialogOpen(true)}
                  className="borderless-btn bg-white"
                />
              </Stack.Item>
            )}
          </Stack>
        </Stack.Item>
        <Stack.Item>
          {state.authorizedContacts && state.authorizedContacts.length > 0 ? (
            <Fabric>
              <DetailsList
                items={state.authorizedContacts}
                columns={
                  ![4].includes(tokenData.role)
                    // ![2, 4].includes(tokenData.role)
                    ? [
                      {
                        key: "name",
                        name: "Name",
                        fieldName: "name",
                        minWidth: 200,
                        maxWidth: 300,
                        isResizable: true,
                      },
                      {
                        key: "email",
                        name: "Email",
                        fieldName: "email",
                        minWidth: 200,
                        maxWidth: 400,
                        isResizable: true,
                      },
                      {
                        key: "phone",
                        name: "Phone",
                        fieldName: "phone",
                        minWidth: 150,
                        maxWidth: 250,
                        isResizable: true,
                      },
                      {
                        key: "datacenterId",
                        name: "Datacenter Name",
                        fieldName: "datacenterId",
                        minWidth: 150,
                        maxWidth: 250,
                        isResizable: true,
                      },
                      {
                        key: "source",
                        name: "Source",
                        fieldName: "source",
                        minWidth: 150,
                        maxWidth: 250,
                        isResizable: true,
                      },
                      {
                        key: "actions",
                        name: "Actions",
                        fieldName: "actions",
                        minWidth: 100,
                        maxWidth: 150,
                        isResizable: true,
                      },
                    ]
                    : [
                      {
                        key: "name",
                        name: "Name",
                        fieldName: "name",
                        minWidth: 200,
                        maxWidth: 300,
                        isResizable: true,
                      },
                      {
                        key: "email",
                        name: "Email",
                        fieldName: "email",
                        minWidth: 200,
                        maxWidth: 400,
                        isResizable: true,
                      },
                      {
                        key: "phone",
                        name: "Phone",
                        fieldName: "phone",
                        minWidth: 150,
                        maxWidth: 250,
                        isResizable: true,
                      },
                      {
                        key: "datacenterId",
                        name: "Datacenter Name",
                        fieldName: "datacenterId",
                        minWidth: 150,
                        maxWidth: 250,
                        isResizable: true,
                      },
                      {
                        key: "source",
                        name: "Source",
                        fieldName: "source",
                        minWidth: 150,
                        maxWidth: 250,
                        isResizable: true,
                      },
                    ]
                }
                compact={true}
                setKey="set"
                onRenderItemColumn={_renderItemColumn as any}
                layoutMode={DetailsListLayoutMode.justified}
                selectionMode={SelectionMode.none}
                onRenderRow={_onRenderRow}
              />
            </Fabric>
          ) : (
            <NoDataTile title="No Authorized Contacts Found for this Customer"></NoDataTile>
          )}
        </Stack.Item>
      </Stack>
      {state.manageActionsCallout.isOpen && (
        <Callout
          styles={{ root: { width: 95, padding: 20 } }}
          role="alertdialog"
          ariaLabelledBy={
            state.manageActionsCallout && state.manageActionsCallout.data?._id
          }
          gapSpace={0}
          target={state.manageActionsCallout.element}
          directionalHint={DirectionalHint.leftCenter}
          onDismiss={() => handleCallOutOpenClose(false)}
        // setInitialFocus={true}
        >
          <Stack tokens={childrenGap8}>
            <Stack.Item className="pointer">
              <span
                onClick={() => {
                  handleDialogOpen(true, state.manageActionsCallout.index);
                }}
                className="callout-options"
              >
                Edit
              </span>
            </Stack.Item>
            <Stack.Item className="pointer">
              <span
                onClick={() => {
                  deleteAc(
                    state.manageActionsCallout.data as IAuthorizedContacts,
                    state.manageActionsCallout.index as number
                  );
                }}
                className="callout-options"
              >
                Delete
              </span>
            </Stack.Item>
          </Stack>
        </Callout>
      )}
      {state.manageAcDialog.isOpen && (
        <ManageAcDialog
          data={state.manageAcDialog.data}
          handleLoading={handleLoading}
          handleDialogClose={(data: IAuthorizedContacts) =>
            handleDialogClose(data)
          }
          customerId={params.customerId}
          allDatacenterDropdown={state.allDatacenterDropdown}
        />
      )}
    </React.Fragment>
  );
};

export default AuthorizationContacts;
